<div class="input-edit-row">
  <input #inputCheck
         class="server-name"
         [ngClass]="{'ng-invalid': noValid }"
         value="{{inputValue}}"
         [disabled]="inputIsDisable"
         [hidden]="inputIsHidden"/>
  <div class="input-edit-btn-area">
    <i *ngIf="isAdmin"
       class="fa fa-edit transition text-tooltip"
       aria-hidden="true"
       title-popup="Edit"
       (click)="inputOnClick(inputListCheck)"
       [hidden]="inputIsHidden"></i>
  </div>
</div>

<div class="input-dynamic-row">
  <div class="input-dynamic-list-area">
    <div *ngFor="let idAray of idsTempArray; let i = index; trackBy: trackByFn"
         [hidden]="inputListIsHidden">
      <input class="widget-create-content add-ids-input"
             onkeypress="return event.keyCode !== 13"
             [(ngModel)]="idsTempArray[i]"
             (change)="editId(i,$event)"
             name="f{{i}}"
             id="f{{i}}"
             #netId="ngModel"
             (input)="validateId(idsTempArray[i], i)"
             autocomplete="off">
      <button class="add-row"
              (click)="removeIds(i, inputListCheck.value)">-
      </button>
      <div *ngIf="trackingPattern[i]"
           class="alert alert-danger alert-validate error-validate">{{patternMessageError}}
      </div>
      <div *ngIf="trackingArr[i]"
           class="alert alert-danger alert-validate error-validate">{{existMessageError}}
      </div>
      <div *ngIf="trackingPattern[i]==false && trackingArr[i] == false && trackingCheck[i]"
           class="alert alert-danger alert-validate error-validate">{{duplicateMessageError}}
      </div>
    </div>

    <div class="last-row-input">
      <input #inputListCheck
             class="widget-create-content add-ids-input"
             [hidden]="inputListIsHidden"
             (input)="validation(inputListCheck.value)"
             autocomplete="off"/>
      <button class="add-row"
              (click)="addIds(inputListCheck.value)"
              [hidden]="inputListIsHidden"
              [disabled]="!addRow"
              [ngClass]="{'disabled': !addRow}">+
      </button>
    </div>
  </div>

  <div class="input-dynamic-btn-area">
    <button class=" transition text-tooltip tooltip-edit"
            title-popup="Save"
            [hidden]="!inputIsHidden"
            [disabled]="duplicatesExist || noValid || netIdExist || disableSaveButtonPattern || disableSaveButtonExist || disableSaveButtonDuplicate || noId"
            (click)="addIds(inputListCheck.value);inputOnSave()">
      <i class="fa fa-check"
         [ngClass]="{'disabled': duplicatesExist || noValid || netIdExist || disableSaveButtonPattern || disableSaveButtonExist || disableSaveButtonDuplicate || noId}"
         aria-hidden="true"></i>
    </button>
    <button class="transition text-tooltip tooltip-edit"
            title-popup="Cancel"
            [hidden]="!inputIsHidden"
            (click)="inputOnCancel(inputCheck)">
      <i class="fa fa-times"
         aria-hidden="true"></i>
    </button>
  </div>
</div>

<div *ngIf="noValid"
     class="alert alert-danger alert-validate error-validate">{{patternMessageError}}
</div>
<div *ngIf="netIdExist"
     class="alert alert-danger alert-validate error-validate">{{existMessageError}}
</div>
<div *ngIf="netIdExist==false && noValid==false && duplicatesExist"
     class="alert alert-danger alert-validate error-validate">{{duplicateMessageError}}
</div>
<div class="alert alert-danger alert-validate error-validate"
     *ngIf="hasError">{{errorMessage}}
</div>

